/* eslint-env browser */

$(document).ready(function () {
  /*** Wow animation init ***/
  if ($(".wow").length) {
    var wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      //animateClass: 'animated', // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: false, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
    });
    wow.init();
  }

  /*** Counting Animation ***/
  if ($(".counting").length) {
    $(".counting").counterUp({
      delay: 10,
      time: 1000,
    });
  }

  /*** Sattelite images animations ***/
  if ($("#sattelite").length) {
    lax.init();

    lax.addDriver(
      "scrollY", // Driver name
      function (laxFrame) {
        return window.scrollY; // Value method
      },
      {} // Options
    );

    // Add animation bindings to elements
    lax.addElements("#sattelite-row-1 div", {
      scrollY: {
        translateX: [
          ["elInY", "elCenterY", "elOutY"],
          {
            991: [0, 0, 0],
            1400: [0, "-(elWidth-screenWidth)/2", "-(elWidth-screenWidth)"],
          },
          /*{
                        easing: 'easeInOutQuad'
                    }*/
        ],
      },
    });

    // Add animation bindings to elements
    lax.addElements("#sattelite-row-2 div", {
      scrollY: {
        translateX: [
          ["elInY", "elCenterY", "elOutY"],
          {
            991: [40, 40, 40],
            1400: ["-(elWidth-screenWidth)", "-(elWidth-screenWidth)/2", 0],
          },
          /*{
                        easing: 'easeInOutQuad'
                    }*/
        ],
      },
    });
  }

  if ($("#products").length) {
    $("#products .owl-carousel").owlCarousel({
      items: 3,
      nav: true,
      autoWidth: true,
      responsive: {
        0: {
          items: 1,
          margin: 20,
        },
        767: {
          items: 2,
          margin: 30,
        },
        992: {
          items: 3,
          margin: 60,
        },
      },
    });
  }

  /*** Scroll to Top ***/
  $(document).on("click", '.hero-btns a[href^="#"]', function (event) {
    event.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $($.attr(this, "href")).offset().top,
      },
      1000
    );
  });

  $(window).on("scroll", function () {
    // Scroll to Top
    function scrollButton() {
      var windowpos = $(window).scrollTop();
      var scrollLink = $(".scroll-top");
      if (windowpos >= 100) {
        scrollLink.fadeIn(300);
      } else {
        scrollLink.fadeOut(300);
      }
    }

    scrollButton();
  });

  /*** Scroll to Target ***/
  if ($(".scroll-to-target").length) {
    $(".scroll-to-target").on("click", function () {
      var target = $(this).attr("data-target");
      // animate
      $("html, body").animate(
        {
          scrollTop: $(target).offset().top,
        },
        1000
      );
    });
  }

  /*** Contact ***/

  const contactForm = $(".contactForm");
  const contactResult = $(".contact-result");

  contactForm.validate({
    debug: false,
    submitHandler: function (contactForm) {
      const values = {};
      $(contactForm)
        .serializeArray()
        .map((field) => {
          const { name, value } = field;
          values[name] = value;
        });

      const {
        url: honeypot,
        emailInput: senderEmail,
        nameInput: senderName,
        messageInput: senderMessage,
      } = values;

      if (honeypot || !senderMessage || !senderName || !senderEmail) {
        return false;
      }

      const webhookBody = {
        content: "@everyone",
        embeds: [
          {
            title: "Contact Form Submitted",
            fields: [
              { name: "Name", value: senderName },
              { name: "Email", value: senderEmail },
              { name: "Message", value: senderMessage },
            ],
          },
        ],
      };

      const webhookUrl = atob(
        "aHR0cHM6Ly9kaXNjb3JkLmNvbS9hcGkvd2ViaG9va3MvOTY5MzI2NTkzMTc0NTYwODQ4L3NDV0VYTWhpalFkcG8tbHNhSW9sXy1rTi1VZzktTFZfMVpzaVlWMVFnSi00eDFvV1dEcFp6cEZVX1BTUmQwN3haaXZz"
      );

      $.ajax({
        type: "POST",
        url: webhookUrl,
        data: JSON.stringify(webhookBody),
        timeout: 20000,
        contentType: "application/json",
        success: function (msg) {
          $(contactResult, contactForm).show().delay(3000).fadeOut(2000);
          $(contactForm)[0].reset();
        },
        // error: $(".thanks").show(),
      });

      return false;
    },
  });

  /* ------------------ Image pointers ------------------ */

  var imagePointer = $(".img-hotspot .img-hotspot-pointer");
  var pointerInfo = $(".img-hotspot .img-hotspot-pointer .info");
  imagePointer.each(function (index) {
    $(this).css("top", $(this).data("spot-y"));
    $(this).css("left", $(this).data("spot-x"));
  });

  pointerInfo.each(function (index) {
    $(this).css("top", $(this).data("info-y"));
    $(this).css("left", $(this).data("info-x"));
  });

  /*** Bg images ***/

  const $bgSection = $(".bg-section-page");

  $bgSection.each(function () {
    const bgSrc = $(this).children("img").attr("src");
    const bgUrl = "url(" + bgSrc + ")";
    $(this).parent().css("backgroundImage", bgUrl);
    $(this).parent().addClass("bg-section-page");
    $(this).remove();
  });

  /*** Page services and products slider ***/

  const $pageGalleryParentElements = $(
    ".tag-service .gallery, .tag-product .gallery"
  );

  $pageGalleryParentElements.each(function () {
    const $figureElement = $(this).find("figure.kg-gallery-card");
    const $pageGalleryImages = $figureElement.find("img");

    const $galleryParent = $("<div class='kg-width-full service-gallery'>");
    const $newGallery = $(
      "<div class='page-carousel owl-carousel carousel-dots carousel-navs' data-slide='4' data-slide-rs='3' data-center='data-center' data-autoplay='true' data-nav='true' data-dots='true' data-space='30' data-loop='true' data-speed='800'></div>"
    );
    const $pageGalleryElement = $(this);

    $pageGalleryImages.each(function () {
      const $owlElement = $('<div class="service-panel"></div>');

      const $panelHolder = $('<div class="service-panel-holder"></div>');

      const $imgContainer = $('<div class="service-img"></div>');

      const imgUrl = $(this).attr("src");
      const $imgElement = $('<img src="' + imgUrl + '" />');
      const $imgHover = $(
        `<div class="service-hover">
                <div class="service-action">
                  <div class="service-zoom">
                    <i class="far fa-eye"></i>
                    <a
                      class="img-gallery-item"
                      href="` +
          imgUrl +
          `"
                      title="wind generators item"
                    ></a>
                  </div>
                </div>
              </div>`
      );

      $imgContainer.append($imgElement);
      $imgContainer.append($imgHover);

      $panelHolder.append($imgContainer);

      $owlElement.append($panelHolder);

      $newGallery.append($owlElement);
    });

    $galleryParent.append($newGallery);

    $pageGalleryElement.replaceWith($galleryParent);
  });

  $(".page-carousel").each(function () {
    const $Carousel = $(this);
    $Carousel.owlCarousel({
      loop: $Carousel.data("loop"),
      autoplay: $Carousel.data("autoplay"),
      margin: $Carousel.data("space"),
      nav: $Carousel.data("nav"),
      dots: $Carousel.data("dots"),
      dotsSpeed: $Carousel.data("speed"),
      mouseDrag: $Carousel.data("drag"),
      touchDrag: $Carousel.data("drag"),
      pullDrag: $Carousel.data("drag"),
      rtl: false,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: $Carousel.data("slide-rs"),
        },
        1000: {
          items: $Carousel.data("slide"),
          center: $Carousel.data("center"),
        },
      },
    });
  });

  $(".img-gallery-item").magnificPopup({
    type: "image",
    gallery: {
      enabled: true,
    },
  });

  /* ------------------ Openlayer map ------------------ */
  function openlayerMap() {
    const map = new ol.Map({
      target: "map",
      layers: [],
      interactions: ol.interaction.defaults({ mouseWheelZoom: false }),
      view: new ol.View({
        center: ol.proj.fromLonLat([26, 44]),
        zoom: 4,
      }),
    });

    addLayersByProps(map, flight.layers);

    addFeaturesLayer(map, flight.prod.features, flight.featuresMinZoom);

    const getSceneByProperty = (sceneName) => {
      for (let scene of flight.scenes) {
        if (scene.name === sceneName) return scene;
      }
    };

    $(".img-hotspot-pointer").on("click", async function () {
      const thisElement = $(this);
      const sceneName = thisElement.attr("scene");

      const scene = getSceneByProperty(sceneName);

      $(".img-hotspot-description").html(scene.description);

      const view = await map.getView();
      changeDataLayersVisibility(map, false, ["bkgnd"]);

      const center = view.getCenter();
      const zoom = view.getZoom();
      const resolution = view.getResolutionForZoom(zoom);

      const distance = ol.sphere.getDistance(
        ol.proj.toLonLat(center),
        ol.proj.toLonLat(scene.center)
      );

      const flightZoom = distance < 500000 ? 9 : distance < 1000000 ? 6 : 3;
      const duration = 8;

      const arrived = (complete) => {
        changeDataLayersVisibility(map, true, ["bkgnd"]);
      };

      view.animate(
        {
          center: scene.center,
          duration: duration * 1000,
          easing: ol.easing.inAndOut,
        },
        arrived
      );
      view.animate(
        {
          zoom: flightZoom,
          duration: (duration * 1000) / 2,
          // easing: ol.easing.easeIn
        },
        {
          zoom: scene.zoom,
          duration: (duration * 1000) / 2,
          // easing: ol.easing.easeOut
        }
      );
    });
  }

  function contactMap() {
    const mapContact = new ol.Map({
      target: "map-contact",
      layers: [],
      interactions: ol.interaction.defaults({ mouseWheelZoom: false }),
      layers: [
        new ol.layer.Tile({
          source: new ol.source.XYZ({
            url: "https://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
            maxZoom: 17,
          }),
        }),
      ],
      view: new ol.View({
        center: ol.proj.fromLonLat([26, 44]),
        zoom: 4,
      }),
    });
  }

  if ($("#map").length) {
    openlayerMap();
  }

  if ($("#map-contact").length) {
    contactMap();
  }

  /*** Three.js 3D animation ***/
  if ($("#particles-js").length) {
    let cycleColor = !1,
      commonHue = 0.196,
      commonColor = new THREE.Color("hsl(196, 67%, 45%)");

    const deviceInfo = (function () {
        const e = window,
          t = (window.screen, document.body),
          s = document.documentElement;
        return {
          screenWidth: () =>
            Math.max(0, e.innerWidth || s.clientWidth || t.clientWidth || 0),
          screenHeight: () =>
            Math.max(0, e.innerHeight || s.clientHeight || t.clientHeight || 0),
          screenRatio() {
            return this.screenWidth() / this.screenHeight();
          },
          screenCenterX() {
            return this.screenWidth() / 2;
          },
          screenCenterY() {
            return this.screenHeight() / 2;
          },
          mouseX: (e) => Math.max(0, e.pageX || e.clientX || 0),
          mouseY: (e) => Math.max(0, e.pageY || e.clientY || 0),
          mouseCenterX(e) {
            return this.mouseX(e) - this.screenCenterX();
          },
          mouseCenterY(e) {
            return this.mouseY(e) - this.screenCenterY();
          },
        };
      })(),
      addEase = (e, t, s) => {
        (e.x += (t.x - e.x) / s),
          (e.y += (t.y - e.y) / s),
          (e.z += (t.z - e.z) / s);
      },
      shootingStar = {
        scene: null,
        stars: [],
        spread: 2500,
        create(e) {
          this.scene = e;
          let t = new THREE.CylinderGeometry(0, 2, 120, 10),
            s = new THREE.MeshBasicMaterial({
              color: 16777164,
              opacity: 0.4,
              blending: THREE.AdditiveBlending,
              side: THREE.FrontSide,
              transparent: !1,
              depthTest: !0,
            }),
            i = THREE.Math.randInt(-this.spread, this.spread),
            o = new THREE.Mesh(t, s);
          o.position.set(i, 300, 200),
            o.rotation.set(Math.PI / 2, 0, 0),
            this.stars.push(o),
            this.scene.add(o);
        },
        update(e) {
          for (let e = 0; e < this.stars.length; e++) {
            let t = this.stars[e];
            t.position.z < -8e3
              ? (this.stars.splice(e, 1), this.scene.remove(t))
              : (t.position.z -= 20);
          }
        },
      },
      groundPlain = {
        group: null,
        geometry: null,
        material: null,
        plane: null,
        simplex: null,
        factor: 380,
        scale: 30,
        speed: 5e-4,
        cycle: 0,
        ease: 10,
        move: { x: 0, y: -300, z: -1e3 },
        look: { x: 29.8, y: 0, z: 0 },
        create(e) {
          (this.group = new THREE.Object3D()),
            this.group.position.set(this.move.x, this.move.y, this.move.z),
            this.group.rotation.set(this.look.x, this.look.y, this.look.z),
            (this.geometry = new THREE.PlaneGeometry(4e3, 2e3, 128, 64)),
            (this.material = new THREE.MeshLambertMaterial({
              color: 16777215,
              emissive: 2697554,
              opacity: 1,
              blending: THREE.NoBlending,
              side: THREE.FrontSide,
              transparent: !1,
              depthTest: !1,
              wireframe: !0,
            })),
            (this.plane = new THREE.Mesh(this.geometry, this.material)),
            this.plane.position.set(0, 0, 0),
            (this.simplex = new SimplexNoise()),
            this.moveNoise(),
            this.group.add(this.plane),
            e.add(this.group);
        },
        moveNoise() {
          for (let e of this.geometry.vertices) {
            let t = e.x / this.factor,
              s = e.y / this.factor + this.cycle,
              i = this.simplex.noise2D(t, s) * this.scale;
            e.z = i;
          }
          (this.geometry.verticesNeedUpdate = !0), (this.cycle += this.speed);
        },
        update(e) {
          this.moveNoise(),
            (this.move.x = -0.04 * e.x),
            addEase(this.group.position, this.move, this.ease),
            addEase(this.group.rotation, this.look, this.ease);
        },
      },
      setupScene = () => {
        const e = new THREE.Scene();
        let t = {
          x: deviceInfo.screenCenterX(),
          y: deviceInfo.screenCenterY(),
        };
        const s = new THREE.WebGLRenderer({
          alpha: !0,
          antialias: !0,
          precision: "mediump",
        });
        s.setSize(deviceInfo.screenWidth(), deviceInfo.screenHeight()),
          s.setPixelRatio(window.devicePixelRatio),
          s.setClearColor(0, 0),
          (s.sortObjects = !0),
          s.domElement.setAttribute("id", "mesh-background"),
          (s.domElement.id = "mesh-background"),
          (s.domElement.style.position = "absolute"),
          (s.domElement.style.left = "0px"),
          (s.domElement.style.top = "0px"),
          (s.domElement.style.width = "100%"),
          (s.domElement.style.height = "100%"),
          document.getElementById("particles-js").appendChild(s.domElement);
        const i = new THREE.PerspectiveCamera(
          60,
          deviceInfo.screenRatio(),
          0.1,
          2e4
        );
        i.position.set(0, 0, 300),
          i.rotation.set(0, 0, 0),
          i.lookAt(e.position);
        const o = new THREE.PointLight(0, 1.1, 1200);
        o.position.set(0, 100, -800),
          (o.castShadow = !1),
          (o.target = e),
          (o.color = commonColor),
          e.add(o),
          groundPlain.create(e),
          window.addEventListener("resize", (e) => {
            (i.aspect = deviceInfo.screenRatio()),
              i.updateProjectionMatrix(),
              s.setSize(deviceInfo.screenWidth(), deviceInfo.screenHeight()),
              (s.domElement.style.width = "100%"),
              (s.domElement.style.height = "100%");
          }),
          window.addEventListener("mousemove", (e) => {
            (t.x = deviceInfo.mouseCenterX(e)),
              (t.y = deviceInfo.mouseCenterY(e));
          });
        const n = () => {
          requestAnimationFrame(n),
            Math.random() > 0.985 && shootingStar.create(e),
            cycleColor &&
              ((commonHue += 0.001) >= 1 && (commonHue = 0),
              commonColor.setHSL(commonHue, 0.8, 0.5)),
            shootingStar.update(t),
            groundPlain.update(t),
            s.render(e, i);
        };
        n();
      };

    setupScene();
  }

  /*** Mobile Menu Trigger ***/
  $(".gh-burger").click(function () {
    $("body").toggleClass("gh-head-open");
  });

  /*** FitVids - Makes video embeds responsive ***/
  $(".gh-content").fitVids();
});
